<template lang="html">
<div data-aos="fade-in" data-aos-duration="1000">
  <b-form @submit.prevent="onSubmit()">
    <h6>Datos de personales</h6>
    <hr class="c-hr" />

    <div class="row">
      <div class="col-12 mt-2">
        <h5 class="f-w-600">SOLICITANTE</h5>
        <hr class="mt-1 mb-2" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <b-form-group class="custom-input" label="Apellido paterno*">
          <b-form-input type="text" v-model="$root.user.lastname_p" size="sm" required placeholder="" />
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group class="custom-input" label="Apellido materno*">
          <b-form-input type="text" v-model="$root.user.lastname_m" size="sm" required placeholder="" />
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group class="custom-input" label="Nombre*">
          <b-form-input type="text" v-model="$root.user.name" size="sm" required placeholder="" />
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <b-form-group class="custom-input" label="Teléfono fijo*">
          <b-form-input type="text" v-model="$root.user.phone" size="sm" required placeholder="" minlength="10" maxlength="10"/>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group class="custom-input" label="Celular*">
          <b-form-input type="text" v-model="$root.user.movil" size="sm" required placeholder="" minlength="10" maxlength="10"/>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group class="custom-input" label="Correo electrónico*">
          <b-form-input type="email" v-model="$root.user.email" size="sm" required placeholder="" />
        </b-form-group>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <h5 class="f-w-600">DOMICILIO</h5>
        <hr class="mt-1 mb-2" />
      </div>

      <div class="col-md-6">
        <b-form-group class="custom-input" label="Calle y número*">
          <b-form-input type="text" v-model="$root.user.street" size="sm" required placeholder="" />
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group class="custom-input" label="Colonia*">
          <b-form-input type="text" v-model="$root.user.neighborhood" size="sm" required placeholder="" />
        </b-form-group>
      </div>

      <div class="col-5 col-lg-3">
        <b-form-group class="custom-input" label="C.P.*">
          <b-form-input type="text" v-model="$root.user.cp" size="sm" required placeholder="" />
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <b-form-group class="custom-input" label="Estado*">
          <b-form-select v-model="$root.user.states_id" required @change="getTowns">
            <b-form-select-option :value="null">Seleccione una opción</b-form-select-option>
            <b-form-select-option :value="st.id" v-for="(st,indx) in statesOpcs" :key="indx">{{st.name}}</b-form-select-option>
           
          </b-form-select>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group class="custom-input" label="Alcaldía o municipio*">
          <b-form-select v-model="$root.user.towns_id" required>
            <b-form-select-option :value="null">Seleccione una opción</b-form-select-option>
            <b-form-select-option :value="town.id" v-for="(town,indx) in townsOpcs" :key="indx">{{town.name}}</b-form-select-option>
          </b-form-select>
        </b-form-group>
      </div>
    </div>

    <!-- <h6 class="mt-5">Dirección</h6>
    <hr class="c-hr" />

    <div class="row mx-0 no-gutters" v-if="$root.user.address">
      <div class="col-md-7 col-lg-6">
        <b-form-group class="custom-input" label="Calle:" label-for="i-calle">
          <b-form-input id="i-calle" type="text" v-model="$root.user.address.street" size="sm" required placeholder="Calle donde vive" />
        </b-form-group>
      </div>

      <div class="col-md pl-md-3">
        <b-form-group class="custom-input" label="Numero ext:" label-for="i-num">
          <b-form-input id="i-numext" type="text" v-model="$root.user.address.num_ext" size="sm" required placeholder="0000" />
        </b-form-group>
      </div>

      <div class="col-md pl-md-3">
        <b-form-group class="custom-input" label="Numero int:" label-for="i-num">
          <b-form-input id="i-numint" type="text" v-model="$root.user.address.num_int" size="sm" placeholder="0000" />
        </b-form-group>
      </div>
    </div>

    <div class="row mx-0 no-gutters" v-if="$root.user.address">
      <div class="col-md-8">
        <b-form-group class="custom-input" label="Colonia:" label-for="i-colonia">
          <b-form-input id="i-colonia" type="text" v-model="$root.user.address.neighborhood" size="sm" required placeholder="Escriba su colonia" />
        </b-form-group>
      </div>

      <div class="col-md pl-md-3">
        <b-form-group class="custom-input" label="Código postal:" label-for="i-cp">
          <b-form-input id="i-cp" type="text" v-model="$root.user.address.zipcode" size="sm" required placeholder="Escriba su código postal" />
        </b-form-group>
      </div>
    </div>


    <div class="row mx-0 no-gutters" v-if="$root.user.address">
      <div class="col-md-6 pr-md-3">
        <b-form-group class="custom-input" label="Estado:" label-for="i-estado">
          <v-select v-model="$root.user.address.state_id" :options="states" label="name" index="id" @change="getTowns"/>
        </b-form-group>
      </div>

      <div class="col-md-6">
        <b-form-group class="custom-input" label="Ciudad:" label-for="i-ciudad">
          <v-select v-model="$root.user.address.town_id" :options="towns" label="name" index="id"/>
        </b-form-group>
      </div>
    </div>
 -->
    <b-button type="submit" class="btn-red btn-form" variant="primary" :disabled="disabled">Guardar cambios</b-button>

  </b-form>

</div>
</template>

<script>
export default {
  data(){
    return{
        statesOpcs: [],
        townsOpcs: [],
        disabled: false,
    }
  },


  methods: {
    getStates(){
      axios.get(tools.url('/api/states')).then((response)=>{
        this.statesOpcs = response.data;
      }).catch((error)=>{
         console.log(error);
      });
    },

    getTowns(){
        if(this.$root.user.states_id){
            axios.get(tools.url('/api/towns/' + this.$root.user.states_id)).then((response)=>{
              this.townsOpcs = response.data;
            }).catch((error)=>{
              console.log(error);
            });
        }else{
            this.towns = [];
        }
    },

    onSubmit(){
        
        this.$root.isLoading = true;
        this.disabled = true;
        const formData = new FormData();

        Object.entries(this.$root.user).forEach(([key, value]) => {
          if (value instanceof File) {
            // Para campos tipo archivo (como el b-form-file)
            formData.append(key, value);
          } else if (Array.isArray(value)) {
            // Si hay arrays (como v-select múltiple), agregarlos como múltiples campos
            value.forEach((val, index) => {
              formData.append(`${key}[${index}]`, val);
            });
          } else if (value !== null && value !== undefined) {
            // Para campos normales
            formData.append(key, value);
          }
        });

        axios.post(tools.url('/api/user/profile'), formData).then((response)=>{
          this.$root.isLoading = false;
            if(response.data.status == 'success'){
                this.disabled = false;
                this.$root.modaldata.icon = 'success';
                this.$root.modaldata.msg = response.data.msg;
                this.$root.modaldata.show = true;
            }else{
                this.disabled = false;
                this.$root.modaldata.icon = 'error';
                this.$root.modaldata.msg = response.data.msg;
                this.$root.modaldata.show = true;
            }
        }).catch((error)=>{
          this.$root.isLoading = false;
            this.disabled = false;
            this.$root.modaldata.icon = 'error';
            this.$root.modaldata.msg = error;
            this.$root.modaldata.show = true;
        });
    },

  },

  beforeMount(){
    this.getStates();
  },

  mounted(){
      if(this.$root.user.states_id){
        this.getTowns();
      }
  }
}
</script>
